module.exports = __webpack_public_path__ + "static/media/logo-short.704f03b1.png";